var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{ dark: _vm.themetype }},[_c('header',[_c('navigation')],1),_c('main',{staticClass:"bodys"},[(false)?_c('notice'):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }